<script lang="ts">
	import { push } from 'svelte-spa-router';
	import { format } from 'svelte-i18n';
	//Helpers
	import { load_image_from, real_id, shellyId16 } from 'src/helpers/interface_helpers';
	//Stores
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
import { rooms } from 'src/stores/lists/rooms';
	import { inputStates } from 'src/stores/features/input-states';
	//Design system components
	import { Text, AdvancedCard, Alert } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../types/Device';
	import { HiddenDevicesRoomID, HiddenRoomObject } from 'src/helpers/service_rooms_helpers';
	import { timestampToDate } from 'src/helpers/date_helper';
	import { capFirstChar } from 'src/helpers/utilities';
	import { setSidePanelState } from '../Sidepanel/sidepanel-helpers';

	let className = 'mb-m';
	export { className as class };
	export let device: Device;

	$: statusStore = getDeviceStatus(device.id);

	$: reporter =
		typeof $inputStates?.[device.id]?.reporter?.id !== 'undefined'
			? $devices[shellyId16($inputStates?.[device.id]?.reporter?.id)]
			: typeof $statusStore?.reporter?.id !== 'undefined'
				? $devices[shellyId16($statusStore?.reporter?.id)]
				: undefined; //getting reporter from interface status SBHT-003C

	$: ts = $inputStates?.[device.id]?.time
		? $inputStates?.[device.id]?.time
		: $statusStore?._updated;
	$: timeString = $statusStore?._updated
		? Date.now() - ts * 1000 < 60000
			? capFirstChar(
					$format(`span_seconds_ago`, {
						default: '{time} seconds ago.',
						values: {
							time: Math.abs(Number(((Date.now() - ts * 1000) / 1000).toFixed(0))),
						},
					}),
				)
			: `${timestampToDate(ts * 1000)}`
		: '';

	const onReporterClick = () => {
		push(`/home/room/${reporter.room_id}/devices`);
		setSidePanelState({ id: reporter.id });
	};

	$: allRooms = {
		...$rooms,
		[HiddenDevicesRoomID]: {
			...HiddenRoomObject,
			name: $format(HiddenRoomObject.name),
		},
	};
</script>

<Text styleType="h2" class="mb-s text-capitalize">
	{$format('title_last_reporter', { default: 'last reporter' })}
</Text>
{#if reporter}
	<AdvancedCard
		aria-label={$format('label_last_reporter', { default: 'Last reporter' })}
		class={className}
		isFocusable
		title={reporter?.name}
		avatar={{
			image: load_image_from(reporter.image, reporter?.server),
		}}
		subtitle={{
			bold: false,
			value: `${$format('process_room', { default: 'Room' })}: ${allRooms[reporter.room_id]?.name}`,
		}}
		description={{
			value: timeString,
			type: 'primary',
		}}
		on:click={onReporterClick}
	/>
{:else}
	<Alert
		class={className}
		isHeadingBold
		type="info"
		heading="N/A"
		message={$format('unknown_last_report_time', {
			default: 'No data about the latest report.',
		})}
	/>
{/if}
